import { ID, WoosatTelecomResponse } from '../../../../../_metronic/helpers'
export type Payment = {
  id?: ID,
  reseller_id?: string,
  payment_method_id?: string,
  amount?: number,
  currency_id?: string,
  transaction_id?: number | null,
  status?: 'completed' | 'pending' | 'failed',
  notes?: string,
  payment_date?: any,
  created_at?:any
}

export type PaymentsQueryResponse = WoosatTelecomResponse<Payment[]>

export const initialPayment: Payment = {
  id: '',
  reseller_id: '',
  payment_method_id: '',
  amount: 0,
  currency_id: '',
  transaction_id: null,
  status: 'completed',
  notes: '',
  payment_date: '',
}
